module.exports = __webpack_public_path__ + "img/icon-register.b14d8d7a.svg";